import styled from "styled-components";
import type { InputHTMLAttributes } from "react";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  hint?: string;
};

export function Input({ label, hint, ...rest }: InputProps) {
  return (
    <Field>
      {label && <Label>{label}</Label>}
      <StyledInput {...rest} />
      {hint && <Hint>{hint}</Hint>}
    </Field>
  );
}

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.xs};
`;

const Label = styled.span`
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme }) => theme.color.textMuted};
  font-weight: ${({ theme }) => theme.font.weight.medium};
`;

const StyledInput = styled.input`
  font-family: inherit;
  font-size: ${({ theme }) => theme.font.size.md};
  color: ${({ theme }) => theme.color.textPrimary};
  background: ${({ theme }) => theme.color.surface};
  border: 1px solid ${({ theme }) => theme.color.borderStrong};
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
  transition: border-color 120ms, box-shadow 120ms;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.color.textMuted};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.color.accent};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.color.accentMuted};
  }

  &:disabled {
    background: ${({ theme }) => theme.color.background};
    cursor: not-allowed;
  }
`;

const Hint = styled.span`
  font-size: ${({ theme }) => theme.font.size.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;
